import { useState, useRef, useTransition} from 'react';
import CleanArabicString from '../auxiliary/CleanArabicString';
import { useData } from '../../context/PhoneDirectoryContext';
import searchStyle from './searchStyle.module.css'



const SearchBox = () => {
  const filterString1 = useRef('');
  const [filterString,setFilterString] = useState('')
  const {data, phoneNames, setFilteredData, filteredData, setLastId} = useData();
  const [isPending, startTransition] = useTransition();

  const handleOnSearchChange = ({ target: { value } }) => {
    setFilterString(value);
    if (typeof filterString === "string" && filterString.length > 1) {
      const ss = CleanArabicString(value);
      const ss1 = ss.split(" ");

      let matches = 0;
      const deps = [];
      phoneNames.forEach((element) => {
        const search_Item = ` ${element.phoneName} ${element.divisionName} `;
        const search_Item2 = CleanArabicString(search_Item);
        ss1.forEach((word) => {
          const i = search_Item2.includes(word.trim());
          matches = i ? matches + 1 : 0;
        });
        if (search_Item2.includes(ss))
          if (!deps.includes(element.divisionName))
            deps.push(element.divisionName);
      });

      startTransition(() => {
        setFilteredData(
          data.filter((depdiv) => {
            return deps.includes(depdiv.divisionName) ? true : false;
          })
        );
        setLastId(filteredData.length)
      });
    } else
      startTransition(() => {
        setFilteredData(() => data);
        setLastId(filteredData.length)
      });
      
  };

  const newSearch = () => {
        setFilterString('');
        startTransition(()=>{
        setFilteredData(()=>data)
        setLastId(filteredData.length)})
        filterString1.current.focus();
  }

  return (
    <div className={searchStyle.box}>
      <button htmlFor="boxinput" className={searchStyle.btn} onClick={newSearch}>
        بحث جديد
      </button>
      <input
        name="boxinput"
        className={searchStyle.input}
        type="search"
        id="filterString"
        onChange={handleOnSearchChange}
        lang="ar"
        ref={filterString1}
        value={filterString}
      />
      {isPending?<span style={{color:'red'}}>جاري البحث</span>:<span></span>}
    </div>
  );
};
export default SearchBox;
